// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.click-to-call-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: var(--sdk-global-white-bg);
  border-radius: 4px;
  overflow: auto;
}
.click-to-call-container .click-to-call-wrapper-container {
  padding: 16px 16px 16px 16px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: center;
}
.click-to-call-container .click-to-call-wrapper-container .call-status-sec {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}
.click-to-call-container .click-to-call-wrapper-container .call-status-sec .dialing-title {
  color: var(--sdk-gloabl-text-color);
  font-size: var(--font-size-text-sm, 14px);
  font-style: normal;
  font-weight: var(--font-weight-normal-Medium, 500);
  line-height: var(--font-line-height-text-sm, 20px);
  opacity: 0.5;
}
.click-to-call-container .click-to-call-wrapper-container .call-status-sec .call-time {
  color: var(--sdk-gloabl-text-color);
  font-size: var(--font-size-text-sm, 14px);
  font-weight: var(--font-weight-normal-Medium, 500);
  line-height: var(--font-line-height-text-sm, 20px);
}
.click-to-call-container .click-to-call-wrapper-container .call-number-input-sec {
  display: flex;
  padding: 8px 10px;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  width: 100%;
}
.click-to-call-container .click-to-call-wrapper-container .call-number-input-sec input {
  color: var(--sdk-gloabl-text-color);
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  width: 100%;
  text-align: center;
  border: 0 !important;
  outline: 0 !important;
  height: 40px;
}
.click-to-call-container .click-to-call-wrapper-container .call-number-input-sec input::placeholder {
  color: var(--sdk-gloabl-text-color);
  opacity: 0.5;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec {
  width: 100%;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data {
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  width: 100%;
  gap: 24px;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .keypad-nums-list {
  gap: 18px;
  justify-content: center;
  align-items: center;
  display: grid;
  grid-template-columns: repeat(3, 51px);
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .keypad-nums-list .keypad-num {
  position: relative;
  display: flex;
  width: 51px;
  height: 51px;
  padding: 11px 10px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  border: 1px solid var(--sdk-gloabl-border-color);
  background: var(--sdk-global-white-bg);
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .keypad-nums-list .keypad-num.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .action-buttons-mute-end-call {
  display: flex;
  gap: 18px;
  justify-content: center;
  align-items: center;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .action-buttons-mute-end-call button {
  display: flex;
  width: 52px;
  padding: 0;
  height: 52px;
  border: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: var(--sdk-gloabl-bg-secondary);
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .action-buttons-mute-end-call button.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.click-to-call-container .click-to-call-wrapper-container .keypad-numbers-data-sec .keypad-numbers-data .action-buttons-mute-end-call button.end-call-button {
  background: var(--colors-foreground-fg-error-primary, #D92D20);
}`, "",{"version":3,"sources":["webpack://./src/plugins/agentDesktop/clickToCallComponent.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,sCAAA;EACA,kBAAA;EACA,cAAA;AAAJ;AACI;EAEI,4BAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAAR;AACQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;AACZ;AAAY;EACI,mCAAA;EACA,yCAAA;EACA,kBAAA;EACA,kDAAA;EACA,kDAAA;EACA,YAAA;AAEhB;AAAY;EACI,mCAAA;EACA,yCAAA;EACA,kDAAA;EACA,kDAAA;AAEhB;AACQ;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;AACZ;AAAY;EACI,mCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,YAAA;AAEhB;AADgB;EACI,mCAAA;EACA,YAAA;AAGpB;AACQ;EACI,WAAA;AACZ;AAAY;EACI,aAAA;EACA,cAAA;EACA,sBAAA;EACA,WAAA;EACA,SAAA;AAEhB;AADgB;EACI,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,sCAAA;AAGpB;AAFoB;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,sCAAA;AAIxB;AAHwB;EACI,YAAA;EACA,mBAAA;AAK5B;AADgB;EACI,aAAA;EACA,SAAA;EACA,uBAAA;EACA,mBAAA;AAGpB;AAFoB;EACI,aAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;AAIxB;AAHwB;EACI,YAAA;EACA,mBAAA;AAK5B;AAHwB;EACI,8DAAA;AAK5B","sourcesContent":["\n.click-to-call-container{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n    background: var(--sdk-global-white-bg);\n    border-radius: 4px;\n    overflow: auto;\n    .click-to-call-wrapper-container{\n        // padding: 80px 16px 16px 16px;\n        padding: 16px 16px 16px 16px;\n        height: 100%;\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        gap: 8px;\n        text-align: center;\n        .call-status-sec{\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            gap: 4px;\n            .dialing-title{\n                color: var(--sdk-gloabl-text-color);\n                font-size: var(--font-size-text-sm, 14px);\n                font-style: normal;\n                font-weight: var(--font-weight-normal-Medium, 500);\n                line-height: var(--font-line-height-text-sm, 20px);\n                opacity: 0.5;\n            }\n            .call-time{\n                color: var(--sdk-gloabl-text-color);\n                font-size: var(--font-size-text-sm, 14px);\n                font-weight: var(--font-weight-normal-Medium, 500);\n                line-height: var(--font-line-height-text-sm, 20px);\n            }\n        }\n        .call-number-input-sec{\n            display: flex;\n            padding: 8px 10px;\n            flex-direction: column;\n            align-items: center;\n            gap: 30px;\n            width: 100%;\n            input{\n                color: var(--sdk-gloabl-text-color);\n                font-size: 14px;\n                font-weight: 400;\n                line-height: 28px;\n                width: 100%;\n                text-align: center;\n                border: 0 !important;\n                outline: 0 !important;\n                height: 40px;\n                &::placeholder{\n                    color: var(--sdk-gloabl-text-color);\n                    opacity: 0.5;\n                }\n            }\n        }\n        .keypad-numbers-data-sec{\n            width: 100%;\n            .keypad-numbers-data{\n                display: flex;\n                margin: 0 auto;\n                flex-direction: column;\n                width: 100%;\n                gap: 24px;\n                .keypad-nums-list{\n                    gap: 18px;\n                    justify-content: center;\n                    align-items: center;\n                    display: grid;\n                    grid-template-columns: repeat(3, 51px);\n                    .keypad-num{\n                        position: relative;\n                        display: flex;\n                        width: 51px;\n                        height: 51px;\n                        padding: 11px 10px;\n                        flex-direction: column;\n                        justify-content: center;\n                        align-items: center;\n                        border-radius: 100px;\n                        border: 1px solid var(--sdk-gloabl-border-color);\n                        background: var(--sdk-global-white-bg);\n                        &.disabled{\n                            opacity: 0.5;\n                            cursor: not-allowed;\n                        }\n                    }\n                }\n                .action-buttons-mute-end-call{\n                    display: flex;\n                    gap: 18px;\n                    justify-content: center;\n                    align-items: center;\n                    button{\n                        display: flex;\n                        width: 52px;\n                        padding: 0;\n                        height: 52px;\n                        border: 0;\n                        flex-direction: column;\n                        justify-content: center;\n                        align-items: center;\n                        border-radius: 100px;\n                        background: var(--sdk-gloabl-bg-secondary);\n                        &.disabled{\n                            opacity: 0.5;\n                            cursor: not-allowed;\n                        }\n                        &.end-call-button{\n                            background: var(--colors-foreground-fg-error-primary, #D92D20);\n                        }\n                    }\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
